var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMyOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 139,
    viewBox: "0 0 197 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.791 63.3127L132.444 34.7503H65.0594L52.1243 63.358V120.177C52.1244 124.146 55.3954 127.417 59.3639 127.417H137.551C141.52 127.417 144.791 124.146 144.791 120.177V63.3127ZM156.374 120.177C156.374 130.543 147.917 139 137.551 139H59.3639C48.9981 139 40.541 130.543 40.541 120.177V60.8694L56.0382 26.5719L57.5823 23.167H140.057L155.899 59.8174L156.374 60.9203V120.177Z",
    fill: "#D5DDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 69.5003H49.2321C45.7571 69.5003 43.4404 67.1837 43.4404 63.7087C43.4404 60.2337 45.7571 57.917 49.2321 57.917H147.69C151.165 57.917 153.482 60.2337 153.482 63.7087C153.482 67.1837 151.165 69.5003 147.69 69.5003Z",
    fill: "#D5DDE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.002 31.8545V63.7087H127.419V31.8545H139.002Z",
    fill: "#D5DDE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5023 31.8545V63.7087H57.9189V31.8545H69.5023Z",
    fill: "#D5DDE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2982 1.22192C30.413 -0.422921 33.3835 -0.406486 35.4755 1.26716L64.4339 24.4338C66.5038 26.0898 67.1823 28.9434 66.0854 31.3567L51.6062 63.2108C50.8524 64.8679 49.3624 66.0753 47.5849 66.4687C45.8072 66.8615 43.9504 66.3922 42.5681 65.2074L2.02641 30.4574C0.70664 29.3262 -0.0391428 27.6647 0.0015855 25.927C0.0429338 24.1894 0.864227 22.5604 2.23568 21.4927L28.2982 1.22192ZM14.9389 26.2777L44.2479 51.4013L53.6707 30.6667L31.7992 13.1672L14.9389 26.2777Z",
    fill: "#D5DDE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.624 1.22192C166.509 -0.422921 163.538 -0.406486 161.446 1.26716L132.488 24.4338C130.418 26.0898 129.74 28.9434 130.836 31.3567L145.316 63.2108C146.069 64.8679 147.559 66.0753 149.337 66.4687C151.115 66.8615 152.971 66.3922 154.354 65.2074L194.895 30.4574C196.215 29.3262 196.961 27.6647 196.92 25.927C196.879 24.1894 196.058 22.5604 194.686 21.4927L168.624 1.22192ZM181.983 26.2777L152.674 51.4013L143.251 30.6667L165.123 13.1672L181.983 26.2777Z",
    fill: "#D5DDE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMyOrders);
export default __webpack_public_path__ + "static/media/empty-my-orders.54e40ca9083b066ba6f258f3ed9321c6.svg";
export { ForwardRef as ReactComponent };